import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/up_arrow.svg")